import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PdpAttributes from './pdpAttributes';
var PdpFacts = function (_a) {
    var plantData = _a.plantData;
    function getTags(data) {
        if (data.tags && data.tags.length > 0) {
            var items = data.tags.map(function (item) { return (React.createElement("li", { key: uniqueId(item.name) },
                React.createElement("a", { href: item.url, className: "btn primary inverted" }, item.name))); });
            return (React.createElement("div", { className: "pdp_details__3" },
                React.createElement("div", { className: "column" },
                    React.createElement("h3", null, "Landscape groups by tags"),
                    React.createElement("ul", { className: "tags_large" }, items))));
        }
        return null;
    }
    return (React.createElement("div", { className: "pdp_facts" },
        React.createElement("h2", { className: "no_padding" },
            "Gardening facts about",
            ' ',
            plantData.title,
            ' ',
            "plant"),
        React.createElement(PdpAttributes, { plantData: plantData, data: plantData.plant_attr }),
        getTags(plantData)));
};
export default PdpFacts;
